import { ConfigProvider } from "antd";
import { CustomThemeProvider } from "customHooks/ThemeContext";
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-loading-skeleton/dist/skeleton.css'
import React, { lazy } from "react";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import MainScreenLoader from "loaders/MainScreenLoader";
import { TableContainerProvider } from "customHooks/tableScrollerContext";

const AppRoutes = lazy(() => import('routes/Routes'));


function App() {
  return (
    <React.Suspense
      fallback={<MainScreenLoader />}
    >
      <CustomThemeProvider>
        <ThemeProvider
          theme={
            {
              primary: "#323C60"
            }
          }>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#323C60",
                colorPrimaryActive: "#323C60",
              },
              components: {
                Timeline: {
                  tailColor: '#D8D8EA'
                }
              }
            }}
          >
            <TableContainerProvider>
              <AppRoutes />
            </TableContainerProvider>
            <ToastContainer />
          </ConfigProvider>
        </ThemeProvider>
      </CustomThemeProvider>
    </React.Suspense>
  );
}

export default App;
